import { render, staticRenderFns } from "./InfoSection.htm?vue&type=template&id=74ecde8b&scoped=true&"
import script from "./InfoSection.ts?vue&type=script&lang=js&"
export * from "./InfoSection.ts?vue&type=script&lang=js&"
import style0 from "./InfoSection.scss?vue&type=style&index=0&id=74ecde8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ecde8b",
  null
  
)

export default component.exports